(function () {
    'use strict';

    angular.module("imApp").factory("postPlaceService", ['$ihttp', function ($ihttp) {
        let service = {
            getPostPlace: function (parms) {
                return $ihttp.post({
                    method: 2208,
                    parameters: parms || {}
                });
            },
            listCommunities: function (parms) {
                return $ihttp.post({
                    method: 2210,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2209,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
